import {
  AugmentationComponent,
  AugmentationToolbarOptionNode
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { resolveToFromLinkProps } from "@pathwright/ux/src/components/link/Link"
import { useMemo } from "react"
import { useHistory } from "react-router-dom"
import AuthorFormContainer from "./item/AuthorFormContainer"
import { loadAuthors, selectAuthor } from "./middleware"

const ContributorManageAugmentationComponent: AugmentationComponent = ({
  route
}) => {
  const history = useHistory()

  const name = useMemo(() => {
    if (!route) return ""
    const searchParams = new URLSearchParams(route.location.search)
    return searchParams.get("name")?.trim() || ""
  }, [route?.location.search])

  function onClose() {
    if (!route) return
    const url =
      route.location.pathname + route.location.search + route.location.hash
    const relativeTo = resolveToFromLinkProps({ relativeTo: "../../" }, url)
    if (relativeTo) history.push(relativeTo)
  }

  return route ? (
    <AuthorFormContainer
      initialName={name}
      // Not supporting deletion for now (submit and delete buttons don't jive).
      canDelete={false}
      closeCard={onClose}
    />
  ) : (
    // Return a fragment instead of null to satisfy the type checker
    <></>
  )
}

export const contributorsManageToolbar: AugmentationToolbarOptionNode = {
  key: "contributor-manage",
  path: "contributors/:authorId(\\d+|new)",
  label: "Contributor",
  middleware: async (route) => {
    await loadAuthors(route)
    await selectAuthor(route)
  },
  AugmentationComponent: ContributorManageAugmentationComponent
}
